import InstitutionFuturesReportingForm from '@/features/institution/futures/reporting/components/form';
import InstitutionDetailsLayout from '@/features/institution/layouts/details';
import { INSTITUTION_DETAILS_TYPE } from '@/features/institution/utils';

const InstitutionFuturesReportingPage = () => {
  return (
    <InstitutionDetailsLayout detailsKey="reporting" detailsType={INSTITUTION_DETAILS_TYPE.FUTURES}>
      <InstitutionFuturesReportingForm />
    </InstitutionDetailsLayout>
  );
};
InstitutionFuturesReportingPage.displayName = 'InstitutionFuturesReportingPage';

export default InstitutionFuturesReportingPage;
